import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface NotificationSubMenuProps {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent<HTMLElement>) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const NotificationSubMenu = ({
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: NotificationSubMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Notifiche ANSC/S.I.De." />
      </ListItem>
      <Menu
        id="Notifiche ANSC/S.I.De.-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
      >
        <MenuItem
          key="Gestione notifiche ANSC-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            navigate('/stato-civile/notifiche/ansc/ricerca/operatore');
            onClose(event);
          }}
        >
          <Typography variant="inherit">Gestione notifiche ANSC</Typography>
        </MenuItem>
        <Divider key="ricerca-notifiche-ansc-per-operatore-divider" />
        <MenuItem
          key="Ricerca notifiche esclusivamente SIDe-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            navigate('/stato-civile/notifiche/side/ricerca');
            onClose(event);
          }}
        >
          <Typography variant="inherit">Notifiche esclusivamente SIDe</Typography>
        </MenuItem>
        <Divider key="ricerca-notifiche-esclusivamente-si-de-divider" />
        <MenuItem
          key="Gestione notifiche ANSC-menu-item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
            navigate('/stato-civile/notifiche/ansc/ricerca');
            onClose(event);
          }}
        >
          <Typography variant="inherit">Ricerca diretta in ANSC</Typography>
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

NotificationSubMenu.displayName = 'Notifications Sub Menu';

export default NotificationSubMenu;
